import DgBreadcrumb from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgBreadcrumb.install = function (Vue) {
  Vue.component(DgBreadcrumb.name, DgBreadcrumb)
}
export default DgBreadcrumb

export { DgBreadcrumb }